import React, { useState, useEffect } from 'react'
import { Chart } from '@scuf/charts'
import baseServices from '../../../services/base.services'

export const CalcinaDespacho = ({ body1, body2, height, showInLegend, name1, name2 }) => {
    const [seca, setSeca] = useState(null)
    const [humeda, setHumeda] = useState(null)

    // CALCINA SECA
    useEffect(() => {
        const getTTeg = async () => {
            var response = await baseServices.getDataTostacionDMH2(body1)
            if (response.data && response.data.length > 0) {
                let arrayValor1 = [], arrayValor2 = []

                response.data.forEach((x, i) => {
                    arrayValor1.push(x.Fecha)
                    arrayValor2.push(x.Valor)
                })

                setSeca({
                    valor1: arrayValor1,
                    valor2: arrayValor2
                })
                // setTimeout(getTTeg(), 60000)
            }
            // setTimeout(getTTeg(), 60000)
        }
        if(body1) getTTeg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // CALCINA HUMEDA
    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getDataTostacionDMH2(body2)
                if (response.data && response.data.length > 0) {
                    let arrayValor1 = []

                    response.data.forEach((x, i) => {
                        arrayValor1.push(x.Valor)
                    })

                    setHumeda({
                        valor1: arrayValor1
                    })
                    setTimeout(() => { getTTeg() }, 60000)
                }
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }
        getTTeg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {
                seca && humeda ?
                    <Chart
                        animation={true}
                        paddingBottom='0'
                        paddingTop='0'
                        height={height}
                    >
                        <Chart.Line
                            showInLegend={showInLegend}
                            name={name1}
                            marker={{
                                enabled: false
                            }}
                            data={humeda.valor1}
                            color='#1792e5'
                        />

                        <Chart.Line
                            showInLegend={showInLegend}
                            name={name2}
                            marker={{
                                enabled: false
                            }}
                            data={seca.valor2}
                            color='#28A745'
                        />

                        <Chart.XAxis
                            categories={seca.valor1}
                        />
                        <Chart.YAxis
                            gridLineWidth='0'
                        />
                    </Chart>
                    :
                    <div className='letter-origin'>...No hay datos</div>
            }
        </>
    )
}

export default CalcinaDespacho